import React, { useEffect, useState } from 'react';
import { Button, ButtonProps } from 'antd';
import { ButtonType } from 'antd/lib/button/button';

export type JButtonProps = ButtonProps & {
  /**
   * primary
   */
  jType?: 'primary' | 'secondary' | 'link';
};

export const JButton: React.FC<JButtonProps> = ({
  jType = 'primary',
  children,
  ...props
}: JButtonProps) => {
  const [type, setType] = useState<ButtonType>('primary');
  useEffect(() => {
    if (props.type) {
      setType(props.type);
    } else if (jType) {
      if (jType === 'secondary') {
        setType('default');
      } else {
        setType(jType);
      }
    } else {
      setType('primary');
    }
  }, [jType, props.type]);

  return (
    <Button type={type} shape={props.shape ? props.shape : 'round'} {...props}>
      {children}
    </Button>
  );
};
